import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { ButtonColor } from '../../../ui/gzIconButton/types';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templatePhasrMonitoredRulesDetailsPanel = document.createElement('template');
templatePhasrMonitoredRulesDetailsPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <gz-progress-spinner spinnerwidth="medium" class="spinner"></gz-progress-spinner>
  <div class="wrapper hidden">
    <gz-title class="phasr-monitored-rules-title" id="rulesTitle" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.HEADING_5}"></gz-title>
    <div class="content-scrollable">
        <div class="section">
            <div id="sectionTitleLabel" class="section-title"></div>
            <div class="section-row">
                <div id="targetedActivityTypeLabel" class="section-row-item key"></div>
                <div id="targetedActivityType"  class="section-row-item value">-</div>
            </div>
            <div class="section-row">
                <div id="ruleTriggerDateLabel" class="section-row-item key"></div>
                <div id="ruleTriggerDate"  class="section-row-item value">-</div>
            </div>
            <div class="section-row">
                <div id="ruleTriggersLabel" class="section-row-item key"></div>
                <div id="ruleTriggers" class="section-row-item value">-</div>
            </div>
            <div class="section-row">
                <div id="recommendationsLabel" class="section-row-item key"></div>
                <div id="recommendations" class="section-row-item value">-</div>
            </div>
            <div class="section-row">
                <div class="section-row-item key" id="behavioralProfilesLabel"></div>
                <gz-tooltip class="section-row-item value" id="behavioralProfilesWrapper"></gz-tooltip>
            </div>
            <div class="section-row">
                <div class="section-row-item key" id="restrictedBehavioralProfilesLabel"></div>
                <gz-tooltip class="section-row-item value" id="restrictedBehavioralProfilesWrapper"></gz-tooltip>
            </div>
            <div class="section-row">
                <div id="incidentsInvolvingRuleTriggersLabel" class="section-row-item key"></div>
                <div class="section-row-item value rule-triggers-wrapper">
                    <div id="incidentsInvolvingRuleTriggers"></div>
                    <gz-link type="quiet" color="${ButtonColor.PRIMARY}" id="incidentsInvolvingRuleTriggersShowMore" class="hidden"></gz-link>
                </div>
            </div>
        </div>
        <div class="section">
            <div id="monitoredRuleDescriptionLabel" class="section-title"></div>
            <div class="section-row">
                <div id="monitoredRuleDescription" class="section-row-description">-</div>
            </div>
        </div>
    </div>
    <gz-button id="accessButton" color="${ButtonColor.PRIMARY}"></gz-button>
  </div>
`;
